import { useEffect, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import Organization from '~/models/organization'
import { NextServiceTourStep, UpdateOrganizationTourPosition, UpdateServiceTourPosition } from '~/modules/tour/actions'
import { GetOrganizationTourStep, GetServiceTourStep } from '~/modules/tour/selectors'
import { ShowModal } from '~/modules/modal/actions'
import { OpenMenu } from '~/modules/persist/menu/actions'

import { getRect } from '~/common/utils/rect'
import { ModalWindow } from '~/common/define/modal'
import { ModalFrameColor } from '~/components/atoms/modal/ModalFrame'
import { ServiceTourProcess } from '~/components/app/modal/content/ServiceTourModal'

export enum OrganizationTour {
  SERVICE_CREATE = 1,
  TOOL_CREATE,
}

export enum ServiceTourStep {
  NONE,
  MENU_NEW,
  MENU_SHOW,
  TOOL_NEW,
  FILE,
  SETTING
}

export const isCompletedOrganizationTour = (organization: Organization) => {
  return organization && organization.member_invited && organization.service_created && organization.tool_created
}

export const useOrganizationPositionSync = (step: OrganizationTour) => {
  const dispatch = useDispatch()
  const ref = useRef()
  const currentStep = useSelector(GetOrganizationTourStep)
  useEffect(() => {
    if (currentStep == step && ref) {
      dispatch(UpdateOrganizationTourPosition(getRect(ref)))
    }
  }, [currentStep, ref])

  return ref
}

export const useServiceTourPositionSync = (step: ServiceTourStep) => {
  const dispatch = useDispatch()
  const ref = useRef()
  const currentStep = useSelector(GetServiceTourStep)
  useEffect(() => {
    if (currentStep == step && ref) {
      dispatch(UpdateServiceTourPosition(getRect(ref)))
    }
  }, [currentStep, ref])

  return ref
}

export const useServiceTourStart = () => {
  const dispatch = useDispatch()

  return () => {
    dispatch(OpenMenu())
    dispatch(ShowModal({
      modal: ModalWindow.SERVICE_TOUR,
      color: ModalFrameColor.SKY,
      childProps: {
        process: ServiceTourProcess.START,
        onComplete: () => {
          dispatch(NextServiceTourStep())
        }
      }
    }))
  }
}

export const useServiceTourEnd = () => {
  const dispatch = useDispatch()

  return () =>
    dispatch(ShowModal({
      modal: ModalWindow.SERVICE_TOUR,
      color: ModalFrameColor.SKY,
      childProps: {
        process: ServiceTourProcess.END,
      }
    }))
}